import React from "react";
import "./formFooter.scss";
import { FormProgressBar } from "./formProgressBar/FormProgressBar";
import { FormControls } from "./formControls/FormControls";
import { useFormProgress } from "../formDetail.service";
export const FormFooter = () => {
	const { progress } = useFormProgress();

	return (
		<div className="formFooter">
			<FormProgressBar value={progress} />
			<FormControls />
		</div>
	);
};
